"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useTopLevelAssets = void 0;
const client_1 = require("@apollo/client");
const graphql_tag_1 = __importDefault(require("graphql-tag"));
function useTopLevelAssets(locationId) {
    var _a, _b, _c;
    const res = client_1.useQuery(QUERY, {
        variables: { locationId },
        context: { locationId },
    });
    return Object.assign(Object.assign({}, res), { data: (_c = (_b = (_a = res.data) === null || _a === void 0 ? void 0 : _a.location) === null || _b === void 0 ? void 0 : _b.units.list) !== null && _c !== void 0 ? _c : null });
}
exports.useTopLevelAssets = useTopLevelAssets;
const QUERY = graphql_tag_1.default `
  query GetTopLevelAssetsQuery($locationId: String!) {
    location(locationId: $locationId) {
      key
      units(
        filter: [
          { name: dataSink, type: empty }
          { name: kiraAssetType, type: any, value: "subUnit" }
        ]
        first: 2000
      ) {
        list {
          key
          unitAddress {
            key
            did
            locationId
          }
          name
          unitTypeFixed
          assetChildren {
            key
            unitTypeFixed
          }
        }
      }
    }
  }
`;
//# sourceMappingURL=useTopLevelAssets.js.map